(ns ui.hyperframes-templates.page
  "The catalog page under /ui/hyperframes-templates: every template
   playing in a loop with its variables, to review new templates.
   Nothing links the route."
  (:require [parts.replicant.query :as query]
            [ui.app-frame :as app-frame]
            [ui.hyperframes-templates.player :as player]))

(def catalog-query
  {:query/kind :query/hyperframes-templates})

(defn variable-row
  [{:keys [id type label default]}]
  [:li {:replicant/key id
        :class ["text-sm" "text-gray-600"]}
   [:span {:class ["font-medium" "text-gray-800"]} label]
   (str " (" id ", " type "): " default)])

(defn template-card
  [template]
  [:div
   {:replicant/key (:template/id template)
    :class ["flex" "gap-6" "rounded-lg" "border" "border-gray-200" "bg-white" "p-4"]}
   [:div
    {:class ["w-[240px]" "shrink-0" "rounded-md" "overflow-hidden" "bg-gray-800"]
     :style {:aspect-ratio "9 / 16"}}
    (player/element {:template-id (:template/id template)
                     :width (:template/width template)
                     :height (:template/height template)
                     :loop? true
                     :style {:display "block"
                             :width "100%"
                             :height "100%"}})]
   [:div
    {:class ["flex" "flex-col" "gap-2" "min-w-0"]}
    [:h2 {:class ["text-lg" "font-semibold" "text-gray-900"]}
     (:template/name template)]
    [:p {:class ["text-sm" "text-gray-600"]}
     (str (:template/id template) ", "
          (/ (:template/duration-ms template) 1000.0) " s, "
          (:template/width template) "x" (:template/height template))]
    (into [:ul {:class ["flex" "flex-col" "gap-1"]}]
          (map variable-row
               (:template/variables template)))]])

(defn panel
  [state]
  [:div
   {:class ["p-6" "flex" "flex-col" "gap-4" "max-w-4xl"]
    :replicant/on-mount (fn [_]
                          ((:replicant/dispatch! state)
                           {:actions [[:data/query catalog-query]]}))}
   [:h1 {:class ["text-2xl" "font-bold" "text-gray-900"]}
    "HyperFrames templates"]
   (if-let [templates (query/get-result state catalog-query)]
     (into [:div {:class ["flex" "flex-col" "gap-4"]}]
           (map template-card templates))
     [:p {:class ["text-sm" "text-gray-600"]} "Loading..."])])

(defn render
  [state]
  (app-frame/app-frame
    state
    (panel state)))

(def page
  {:page-id :pages/hyperframes-templates
   :route [["ui" "hyperframes-templates"]]
   :render #'render})
